import clsx from "clsx";
import { ComponentProps } from "react";

type MacWindowProps = ComponentProps<"div">;

const MacWindow = (props: MacWindowProps) => {
  const { children, className, ...rest } = props;
  return (
    <div
      {...rest}
      className={clsx(
        "Mac__window bg-gray-100  rounded-lg min-w-[375px] shadow-lg",
        className
      )}
    >
      <div className="Mac__header flex items-center p-2 bg-gray-200 rounded-t-lg">
        <div className="flex space-x-2 ml-2">
          <span className="w-3 h-3 bg-red-500 rounded-full"></span>
          <span className="w-3 h-3 bg-yellow-500 rounded-full"></span>
          <span className="w-3 h-3 bg-green-500 rounded-full"></span>
        </div>
      </div>
      <div className="Mac__content p-4 bg-white rounded-b-lg">{children}</div>
    </div>
  );
};

export default MacWindow;
